export interface PanelData {
  tx: number;
  ty: number;
  angle: number;
  scaleX: number;
  scaleY: number;
  duration: number;
}

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { app } from "../core/App";
/* END-USER-IMPORTS */

export default class IntroSequence extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // page
    const page = scene.add.container(0, 0);
    this.add(page);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 800);
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    page.add(cover);

    // panel1
    const panel1 = scene.add.image(0, -174, "intro", "cell_1.png");
    panel1.visible = false;
    page.add(panel1);

    // panel2
    const panel2 = scene.add.image(-186, 172, "intro", "cell_2.png");
    panel2.visible = false;
    page.add(panel2);

    // panel3
    const panel3 = scene.add.image(-370, -160, "intro", "cell_3.png");
    panel3.visible = false;
    page.add(panel3);

    // panel4
    const panel4 = scene.add.image(162, -161, "intro", "cell_4.png");
    panel4.visible = false;
    page.add(panel4);

    // panel5
    const panel5 = scene.add.image(-156, 185, "intro", "cell_5.png");
    panel5.visible = false;
    page.add(panel5);

    // panel6
    const panel6 = scene.add.image(309, 177, "intro", "cell_6.png");
    panel6.visible = false;
    page.add(panel6);

    // panel7
    const panel7 = scene.add.image(-264, -205, "intro", "cell_7.png");
    panel7.visible = false;
    page.add(panel7);

    // panel8
    const panel8 = scene.add.image(220, -182, "intro", "cell_8.png");
    panel8.visible = false;
    page.add(panel8);

    // panel9
    const panel9 = scene.add.image(0, 195, "intro", "cell_9.png");
    panel9.visible = false;
    page.add(panel9);

    // cash1
    const cash1 = scene.add.image(-186, -256, "intro", "intro_note.png");
    cash1.scaleX = 0.6;
    cash1.visible = false;
    page.add(cash1);

    // cash2
    const cash2 = scene.add.image(393, -302, "intro", "intro_cash.png");
    cash2.scaleX = 0.6;
    cash2.scaleY = 0.6;
    cash2.angle = 25;
    cash2.visible = false;
    page.add(cash2);

    // cash3
    const cash3 = scene.add.image(453, -19, "intro", "intro_note.png");
    cash3.scaleX = 0.7;
    cash3.scaleY = 0.7;
    cash3.visible = false;
    page.add(cash3);

    // cash4
    const cash4 = scene.add.image(-160, -8, "intro", "intro_note.png");
    cash4.scaleX = 0.5;
    cash4.scaleY = 0.5;
    cash4.angle = 156;
    cash4.visible = false;
    page.add(cash4);

    // cash5
    const cash5 = scene.add.image(-54, -117, "intro", "intro_note.png");
    cash5.scaleX = 0.4;
    cash5.scaleY = 0.4;
    cash5.angle = -49;
    cash5.visible = false;
    page.add(cash5);

    // cash6
    const cash6 = scene.add.image(400, -146, "intro", "intro_note.png");
    cash6.scaleX = 0.3;
    cash6.scaleY = 0.3;
    cash6.angle = 121;
    cash6.visible = false;
    page.add(cash6);

    // lists
    const page1 = [panel1, panel2, panel3];
    const page2 = [panel4, panel5, panel6];
    const page3 = [panel7, panel8, panel9];
    const cash = [cash1, cash2, cash3, cash4, cash5, cash6];
    const page2alt = [panel3, panel4, panel5, panel6];

    this.page = page;
    this.cover = cover;
    this.panel1 = panel1;
    this.panel2 = panel2;
    this.panel3 = panel3;
    this.panel4 = panel4;
    this.panel5 = panel5;
    this.panel6 = panel6;
    this.panel7 = panel7;
    this.panel8 = panel8;
    this.panel9 = panel9;
    this.cash1 = cash1;
    this.cash2 = cash2;
    this.cash3 = cash3;
    this.cash4 = cash4;
    this.cash5 = cash5;
    this.cash6 = cash6;
    this.page1 = page1;
    this.page2 = page2;
    this.page3 = page3;
    this.cash = cash;
    this.page2alt = page2alt;

    /* START-USER-CTR-CODE */
    this.cover.alpha=0;
    /* END-USER-CTR-CODE */
  }

  private page: Phaser.GameObjects.Container;
  private cover: Phaser.GameObjects.Rectangle;
  private panel1: Phaser.GameObjects.Image;
  private panel2: Phaser.GameObjects.Image;
  private panel3: Phaser.GameObjects.Image;
  private panel4: Phaser.GameObjects.Image;
  private panel5: Phaser.GameObjects.Image;
  private panel6: Phaser.GameObjects.Image;
  private panel7: Phaser.GameObjects.Image;
  private panel8: Phaser.GameObjects.Image;
  private panel9: Phaser.GameObjects.Image;
  private cash1: Phaser.GameObjects.Image;
  private cash2: Phaser.GameObjects.Image;
  private cash3: Phaser.GameObjects.Image;
  private cash4: Phaser.GameObjects.Image;
  private cash5: Phaser.GameObjects.Image;
  private cash6: Phaser.GameObjects.Image;
  private page1: Phaser.GameObjects.Image[];
  private page2: Phaser.GameObjects.Image[];
  private page3: Phaser.GameObjects.Image[];
  private cash: Phaser.GameObjects.Image[];
  private page2alt: Phaser.GameObjects.Image[];

  /* START-USER-CODE */
  public static events = {
    SequenceStarted: 'sequenceStarted',
    SequenceFinished: 'SequenceFinished'
  } as const;

  public showStory() {

    let cashData: PanelData[] = [
      {
        tx: 0,
        ty: 0,
        angle: 0,
        scaleX: 0,
        scaleY: 0,
        duration: 0
      },
      {
        tx: 0,
        ty: 0,
        angle: 0,
        scaleX: 0,
        scaleY: 0,
        duration: 0
      },
      {
        tx: 0,
        ty: 0,
        angle: 0,
        scaleX: 0,
        scaleY: 0,
        duration: 0
      },
      {
        tx: 0,
        ty: 0,
        angle: 0,
        scaleX: 0,
        scaleY: 0,
        duration: 0
      },
      {
        tx: 0,
        ty: 0,
        angle: 0,
        scaleX: 0,
        scaleY: 0,
        duration: 0
      },
      {
        tx: 0,
        ty: 0,
        angle: 0,
        scaleX: 0,
        scaleY: 0,
        duration: 0
      }
    ];

    for (let i = 0; i < cashData.length; i++) {
      const cashImage = this.cash[i];
      cashData[i].tx = cashImage.x;
      cashData[i].ty = cashImage.y;
      cashData[i].angle = cashImage.angle;
      cashData[i].scaleX = cashImage.scaleX;
      cashData[i].scaleY = cashImage.scaleY;
      cashImage.x = 0;
      cashImage.y =-161;
      cashImage.angle=0;
      cashImage.scaleX = 0;
      cashImage.scaleY = 0;
    }


    let page1Data: PanelData[] = [
      {
        tx: 0,
        ty: -1000,
        angle: 0,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: -1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: -1000,
        ty: 100,
        angle: 350,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: 100,
        angle: 20,
        scaleX: 1.2,
        scaleY: 1.2,
        duration: 350
      }
    ];

    let page2Data: PanelData[] = [
      {
        tx: -1000,
        ty: -100,
        angle: 50,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: 100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: -1000,
        ty: 100,
        angle: -10,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: 100,
        angle: 60,
        scaleX: 1.2,
        scaleY: 1.2,
        duration: 350
      }
    ];

    let page3Data: PanelData[] = [
      {
        tx: -1000,
        ty: -100,
        angle: 50,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 0,
        ty: 300,
        angle: 0,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      }
    ];

    let startDelay = 0;
    let firstPageDelay = 0;
    let pageStartDelay = 500;
    let panelTime = 1500;
    let pageTime = panelTime * 4;
    let pageTotalTime = pageStartDelay + pageTime;
    let endDelay = 1500;

    let initialDelay = startDelay + firstPageDelay;

    this.clearAll();
    this.emit(IntroSequence.events.SequenceStarted);
   // this.raisePage(startDelay);

    // 3 Page Version.
    // this.scene.time.delayedCall(initialDelay, this.showPage, [this.page1, page1Data, pageStartDelay, panelTime], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1, this.clearPanels, [this.page1], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1, this.showPage, [this.page2, page2Data, pageStartDelay, panelTime], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1.2, this.showCash, [cashData], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 2, this.clearPanels, [this.page2], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 2, this.clearCash, [], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 2, this.showPage, [this.page3, page3Data, pageStartDelay, panelTime], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 3, this.clearPanels, [this.page3], this);
    // this.scene.time.delayedCall(endDelay + initialDelay + pageStartDelay * 2 + pageTotalTime * 3, () => {
    //   this.emit(IntroSequence.events.SequenceFinished);
    // });

    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.1, this.playFX, ["SndBadIntro1"], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.7, this.playFX, ["SndSnowyBoost1"], this);
    // //this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.1, this.playFX, ["SndQuizzCaught1"], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.12, this.playFX, ["SndBamBoost1"], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.53, this.playFX, ["SndJestahFire1"], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.1, this.playFX, ["SndQuizzCaught1"], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.5, this.playFX, ["SndBamBoost1"], this);
    // this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.6, this.playFX, ["SndBamCheer1"], this);

    // 2 Page Version.
    this.scene.time.delayedCall(initialDelay, this.showPage, [this.page2alt, page2Data, pageStartDelay, panelTime], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.4, this.showCash, [cashData], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1, this.clearPanels, [this.page2alt], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1, this.clearCash, [], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1, this.showPage, [this.page3, page3Data, pageStartDelay, panelTime], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 2, this.clearPanels, [this.page3], this);
    this.scene.time.delayedCall(endDelay + initialDelay + pageStartDelay * 1 + pageTotalTime * 2, () => {
      this.emit(IntroSequence.events.SequenceFinished);
    });

    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.1, this.playFX, ["SndBadIntro1"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.35, this.playFX, ["SndSnowyBoost1"], this);
    //this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.1, this.playFX, ["SndQuizzCaught1"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.55, this.playFX, ["SndBamBoost1"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.83, this.playFX, ["SndJestahFire1"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.1, this.playFX, ["SndQuizzCaught1"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.5, this.playFX, ["SndBamBoost1"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.6, this.playFX, ["SndBamCheer1"], this);
  }

  protected showCash(cashData: PanelData[]){

    var delay = 0;
    for (let i = 0; i < cashData.length; i++) {
      const cashImage = this.cash[i];
      cashImage.visible = true;

      this.scene.add.tween({
        targets: cashImage,
        x: cashData[i].tx,
        y: cashData[i].ty,
        alpha: 1,
        angle: cashData[i].angle,
        scaleX: cashData[i].scaleX,
        scaleY: cashData[i].scaleY,
        duration: 500,
        ease: Phaser.Math.Easing.Cubic.InOut,
        delay: delay,
        onComplete: () => {
          this.scene.add.tween({
            targets: cashImage,
            scaleX: cashImage.scaleX*1.03,
            scaleY: cashImage.scaleY*1.03,
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
          });
        }
      });
      delay+=20;
    }
  }

  protected clearCash(){

    var delay = 0;
    for (let i = 0; i < this.cash.length; i++) {
      const cashImage = this.cash[i];


      this.scene.add.tween({
        targets: cashImage,

        alpha: 0,

        duration: 150,
        ease: Phaser.Math.Easing.Cubic.InOut,
        delay: delay,

      });
      //delay+=40;
    }
  }

  protected clearAll() {
    for (const panel of this.page1) {
      panel.setVisible(false);
    }

    for (const panel of this.page2) {
      panel.setVisible(false);
    }

    for (const panel of this.page3) {
      panel.setVisible(false);
    }
  }

  protected darkenSky(){

    this.scene.add.tween({
      targets: this.cover,
      alpha:1,
      duration: 4000,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }



  protected playFX(fxname:string){
    app.audioHandler.playSound(this.scene, fxname, 'sfx');
  }


  protected raisePage(delay: number) {
    let startingScale = this.page.scale;
    let startingY = this.page.y;

    this.page.setScale(2);
    this.page.y = 1200;

    this.scene.add.tween({
      targets: this.page,
      y: startingY,
      scaleX: startingScale,
      scaleY: startingScale,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: delay
    });
  }

  protected lowerPage() {
    this.scene.add.tween({
      targets: this.page,
      y: 1000,
      scaleX: 1.5,
      scaleY: 1.5,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In
    });
  }

  protected clearPanels(panels: Phaser.GameObjects.Image[]) {
    for (const panel of panels) {
      this.scene.add.tween({
        targets: panel,
        alpha: 0,
        duration: 1000,
        ease: Phaser.Math.Easing.Cubic.InOut
      });

      // panel.setVisible(false);
    }
  }

  protected showPage(panels: Phaser.GameObjects.Image[], panelData: PanelData[], delay: number, delayPerPanel: number) {
    for (let i = 0; i < panels.length; i++) {
      const panel = panels[i];

      let tx = panel.x;
      let ty = panel.y;
      let alpha = panel.alpha;
      let tr = panel.angle;
      let sx = panel.scaleX;
      let sy = panel.scaleY;

      panel.x += panelData[i].tx;
      panel.y += panelData[i].ty;
      panel.alpha = 0;
      panel.angle = panelData[i].angle;
      panel.scaleX = panelData[i].scaleX;
      panel.scaleY = panelData[i].scaleY;

      this.scene.add.tween({
        targets: panel,
        x: tx,
        y: ty,
        alpha: alpha,
        angle: tr,
        scaleX: sx,
        scaleY: sy,
        duration: panelData[i].duration,
        ease: Phaser.Math.Easing.Cubic.InOut,
        delay: delay,
        onStart: () => {
          panel.setVisible(true);
        }
      });

      delay += delayPerPanel;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
